import Footer from "@/components/general/common/Footer";
import NavigationTop from "@/components/general/Navigation/NavigationTop";
import { Toaster } from "@/components/shadcn/sonner";

interface PageNotFoundProps {
    hideLayout?: boolean;
}

export function PageNotFound({ hideLayout = false }: PageNotFoundProps) {
    const content = (
        <div className="text-center space-y-4">
            <h1 className="text-6xl font-bold text-red-accent">404</h1>
            <h2 className="text-2xl font-semibold text-white">Page Not Found</h2>
            <p className="text-white">The page you're looking for doesn't exist.</p>
        </div>
    );

    if (hideLayout) {
        return (
            <div className="h-full flex items-center justify-center p-4">
                {content}
                <Toaster />
            </div>
        );
    }

    return (
        <div className="h-screen flex flex-col overflow-hidden">
            <NavigationTop />
            <div className="flex-1 min-h-0 overflow-auto h-full my-4 mx-4 p-4 flex items-center justify-center">
                {content}
            </div>
            <Footer />
            {/* <Vally /> */}
            <Toaster />
        </div>
    );
}
